import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
	name: "sortByProp",
})
export class SortByPropPipe implements PipeTransform {
	transform(
		arr: any[],
		field: string,
		isAsc: boolean,
		type: "string" | "date" = "string"
	): any[] {
		return arr.toSorted((a, b) => {
			const [aVal, bVal] = [a[field], b[field]]
			const [first, sec] = isAsc ? [aVal, bVal] : [bVal, aVal]
			return type === "date"
				? new Date(first).getTime() - new Date(sec).getTime()
				: (first || "").localeCompare(sec || "")
		})
	}
}
